import React, { useEffect, useRef } from 'react';
/**
 * Simple component which is used to keep the scroll of the container parent targeted on it.
 */
export function ScrollToTarget({ children }) {
    const elementRef = useRef(null);
    useEffect(() => elementRef.current.scrollIntoView({ behavior: 'smooth' }));
    return (
        <div ref={elementRef} data-role={'scroll-target'}>
            {children}
        </div>
    );
}
